import React, { Component } from 'react';
import Iframe from 'react-iframe';

class TeamsMap extends Component {
  constructor(props) {
      super(props);
      this.state = {
        data: []
      };
  }
  render() {
    var baseResultsURL = "https://roadtonationals.com/results/chartsContent/ch_teamsmapMReact.php";
    var d = new Date();
    var url = baseResultsURL + '?t=' + d.getTime();
    return (
      <div>
      <Iframe url={url}
          width="100%"
          height="800px"
          display="initial"
          position="relative"
          allowFullScreen/>
      </div>
    );
  }
}

export default TeamsMap;



// WEBPACK FOOTER //
// ./src/components/TeamsMap.js